module.exports = __webpack_public_path__ + "static/smi6-175bb75735b80dac3a2eda5028ce9296.png";